﻿const culture = document.getElementById("culture").value,
      siteId = document.getElementById("siteId").value;

const cookieValue = document.cookie
    .split('; ')
    .find(row => row.startsWith('boats'));

const splitCookie = (cookieValue || "").split('=')[1] || "";
let boatIds = splitCookie.split(",");
if (boatIds[0] === "") {
    boatIds = [];
}

if (document.getElementsByClassName("compare-boat").length) {
    document.querySelector(".compare-boat").addEventListener("click", addBoatByClick);
}

function addBoat(id) {
    let index = boatIds.indexOf(id);
    if (index === -1) {
        boatIds.push(id);
        setComparisonCookie();
    }

    loadComparison();
}

function setComparisonCookie() {
    let newValue = boatIds.join(",");
    document.cookie = "boats=" + newValue + ";path=/;samesite=strict";
}

function addBoatByClick(evt) {
    var id = evt.currentTarget.attributes["data-model-id"].value;
    addBoat(id);
}

function addBoatByDropDown(evt) {
    let selects = Array.from(document.querySelectorAll(".compare-boat-picker"));
    let index = selects.indexOf(evt.currentTarget);
    boatIds[index] = evt.currentTarget.value;
    setComparisonCookie();
    loadComparison();
}

function removeBoatFromComparison(evt){
    let boatKey = evt.currentTarget.attributes["data-model-id"].value;
    boatIds.splice(boatKey, 1);

    setComparisonCookie();
    loadComparison();
}

function loadComparison() {
    if (boatIds.length == 0) {
        document.getElementById("boat-comparison").innerHTML = "";
        return;
    }
    fetch(`/umbraco/surface/boatcomparison/comparison?culture=${culture}&siteId=${siteId}`)
        .then(response => {
            response.text()
                .then(html => {
                    document.getElementById("boat-comparison").innerHTML = html;

                    document.querySelectorAll(".compare-boat-picker").forEach(
                        e => {
                            e.addEventListener("change", addBoatByDropDown);
                        });

                    document.querySelectorAll(".remove-boat-comparison").forEach(
                        e => {
                            e.addEventListener("click", removeBoatFromComparison);
                        });
                });
        });
}